import { ExpandLess } from '@material-ui/icons';
import { API } from './actions';

export const OK_CODE = 200;
export const CREATED_CODE = 201;
export const BAD_REQUEST_CODE = 400;
export const UNAUTHORIZED_CODE = 401;
export const FORBIDDEN_CODE = 403;
export const NOT_FOUND_CODE = 404;
export const NOT_ACCEPTABLE_CODE = 406;
export const GONE_CODE = 410;
export const UNPROCESSABLE_ENTITY_CODE = 422;
export const TOO_MANY_REQUESTS_CODE = 429;
export const INTERNAL_SERVER_ERROR_CODE = 500;
export const SERVICE_UNAVAILABLE_CODE = 503;

export const CODE_ACTIONS = {
    [BAD_REQUEST_CODE]: API.BAD_REQUEST,
    [UNAUTHORIZED_CODE]: API.UNAUTHORIZED,
    [FORBIDDEN_CODE]: API.FORBIDDEN,
    [NOT_FOUND_CODE]: API.NOT_FOUND,
    [UNPROCESSABLE_ENTITY_CODE]: API.UNPROCESSABLE_ENTITY,
    [INTERNAL_SERVER_ERROR_CODE]: API.INTERNAL_SERVER_ERROR,
    [SERVICE_UNAVAILABLE_CODE]: API.SERVICE_UNAVAILABLE
};
